import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BasefieldV2Component } from '../basefield-v2/basefield-v2.component';

@Component({
  selector: 'card-number-v2',
  templateUrl: './card-number-v2.component.html',
  styleUrls: ['./card-number-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardNumberV2Component extends BasefieldV2Component {}
